
export const EMPLOYEE_SALES_COMMISSION_DETAILS_FIELDS = [
    
  {
    field: 'salesPersonName',
    label: 'Sales Person',
  },
  {
    field: 'invoiceNo',
    label: 'Num',
    cell: 'formatLink',
    route: 'invoices.edit'
  },
  {
    field: 'invoiceDate',
    label: 'Date',
    cell: 'formatDate',
  },
  {
    field: 'companyName',
    label: 'Company'
  },
  {
    field: 'subTotal',
    label: 'Sub Total',
    cell: 'formatMoney'
  },
  {
    field: 'charges',
    label: 'Charges',
    cell: 'formatMoney'
  },
  {
    field: 'total',
    label: 'Total',
    cell: 'formatMoney'
  },
  {
    field: 'itemCost',
    label: 'Item Cost',
    cell: 'formatMoney'
  },
  {
    field: 'expenses',
    label: 'Addt\'l Cost',
    cell: 'formatMoney'
  },
  {
    field: 'profit',
    label: 'Profit',
    cell: 'formatMoney'
  },
  {
    field: 'margin',
    label: 'Margin',
    cell: 'formatPercentage'
  },
  {
    field: 'commission',
    label: 'Commission',
    cell: 'formatMoney'
  },
  {
    field: 'invoiceNo',
    label: 'Action',
    sortable: false,
    cell: 'viewPurchaseBtn'
  }
  
]

export const PURCHASE_INFO_FIELDS = [
  {
    field: 'purchaseOrderId',
    label: 'PO No',
    cell: 'formatLink',
    route: 'purchaseorders.edit'
  },
  {
    field: 'quantity',
    label: 'Qty'
  },
  {
    field: 'price',
    label: 'Cost',
    cell: 'formatPrice'
  },
  {
    field: 'partNumber',
    label: 'Part Number'
  },
  {
    field: 'mfr',
    label: 'Mfr'
  },
  {
    field: 'conditionName',
    label: 'Condition'
  },
  {
    field: 'dateCode',
    label: 'Date Code'
  },
  {
    field: 'total',
    label: 'Total',
    cell: 'formatMoney'
  },
  {
    field: 'isPurchaseCommissionPaid',
    label: 'Paid Commission?',
    cell: 'formatBool'
  },
]

export const SALES_COMMISSION_LIST_FIELDS = [
  {
    field: 'id',
    title: 'Id'
  },
  {
    field: 'userFullName',
    title: ' Sales Person'
  },
  { 
    field: 'commissionDate',
    title: ' Commission Date',
    cell: 'formatDate'
  },
  {
    field: 'amount',
    title: ' Amount',
    cell: 'formatCurrencyConverted'
  },
  {
    field: 'createdByUserFullName',
    title: ' Created By'
  },
  {
    field: 'modifiedByUserFullName',
    title: ' Modified By'
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export const SALES_COMMISSION_LINES_FIELDS = [
  {
    field: 'commissionTypeName',
    label: ' Type'
  },
  {
    field: 'invoiceId',
    label: 'Invoice No',
    cell: 'formatLink',
    route: 'invoices.edit'
  },
  { 
    field: 'invoiceCompany',
    label: 'Company'
  },
  {
    field: 'invoiceTotal',
    label: 'Total',
    cell: 'formatMoney'
  },
  {
    field: 'grossProfit',
    label: 'Profit',
    cell: 'formatMoney'
  },
  {
    field: 'gpMargin',
    label: 'Margin',
    cell: 'formatPercentage'
  },
  {
    field: 'saleCommissionRate',
    label: 'C. Rate',
    cell: 'formatPercentage',
  },
  {
    field: 'amount',
    label: 'C. Amount',
    cell: 'formatMoney'
  },
  {
    field: 'invoiceId',
    label: 'Purchases',
    sortable: false,
    cell: 'viewPurchaseBtn'
  },
  {
    field: 'id',
    label: 'Comment',
    cell: 'popUpCommentFieldBtn'
  },
  {
    field: 'id',
    label: 'Remove',
    sortable: false,
    cell: 'deleteBtn'
  }
]



export const EMPLOYEE_PURCHASE_COMMISSION_DETAILS_FIELDS = [
    
  {
    field: 'buyerRepName',
    label: 'Buyer Rep',
  },
  {
    field: 'purchaseOrderNo',
    label: 'Num',
    cell: 'formatLink',
    route: 'purchaseorders.edit'
  },
  {
    field: 'poDate',
    label: 'Date',
    cell: 'formatDate',
  },
  {
    field: 'companyName',
    label: 'Company'
  },
  {
    field: 'subTotalConverted',
    label: 'Sub Total',
    cell: 'formatMoney'
  },
  {
    field: 'totalChargesConverted',
    label: 'Charges',
    cell: 'formatMoney'
  },
  {
    field: 'totalConverted',
    label: 'Total',
    cell: 'formatMoney'
  },
  {
    field: 'buyerRepCommissionRate',
    label: 'C. Rate',
    cell: 'formatComputePercentage'
  },
  {
    field: 'commissionAmount',
    label: 'Commission',
    cell: 'formatMoney'
  },
  {
    field: 'purchaseOrderNo',
    label: 'Action',
    sortable: false,
    cell: 'viewSalesBtn'
  }
  
]

export const SALES_INFO_FIELDS = [
  {
    field: 'invoiceId',
    label: 'Invoice No',
    cell: 'formatLink',
    route: 'invoices.edit'
  },
  {
    field: 'quantity',
    label: 'Qty'
  },
  {
    field: 'price',
    label: 'Cost',
    cell: 'formatPrice'
  },
  {
    field: 'partNumber',
    label: 'Part Number'
  },
  {
    field: 'mfr',
    label: 'Mfr'
  },
  {
    field: 'conditionName',
    label: 'Condition'
  },
  {
    field: 'dateCode',
    label: 'Date Code'
  },
  {
    field: 'total',
    label: 'Total',
    cell: 'formatMoney'
  },
  {
    field: 'isPurchaseCommissionPaid',
    label: 'Paid Commission?',
    cell: 'formatBool'
  },
]

export const PURCHASE_COMMISSION_LIST_FIELDS = [
  {
    field: 'id',
    title: 'Id'
  },
  {
    field: 'userFullName',
    title: ' Sales Person'
  },
  { 
    field: 'commissionDate',
    title: ' Commission Date',
    cell: 'formatDate'
  },
  {
    field: 'amount',
    title: ' Amount',
    cell: 'formatCurrencyConverted'
  },
  {
    field: 'createdByUserFullName',
    title: ' Created By'
  },
  {
    field: 'modifiedByUserFullName',
    title: ' Modified By'
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export const PURCHASE_COMMISSION_LINES_FIELDS = [
  {
    field: 'commissionTypeName',
    label: ' Type'
  },
  {
    field: 'purchaseOrderId',
    label: 'PO No',
    cell: 'formatLink',
    route: 'purchaseorders.edit'
  },
  { 
    field: 'purchaseOrderCompany',
    label: 'Company'
  },
  {
    field: 'purchaseOrderTotal',
    label: 'Total',
    cell: 'formatMoney'
  },
  {
    field: 'purchaseCommissionRate',
    label: 'C. Rate',
    cell: 'formatPercentage',
  },
  {
    field: 'amount',
    label: 'C. Amount',
    cell: 'formatMoney'
  },
  {
    field: 'purchaseOrderId',
    label: 'Purchases',
    sortable: false,
    cell: 'viewSalesBtn'
  },
  {
    field: 'id',
    label: 'Comment',
    cell: 'popUpCommentFieldBtn'
  },
  {
    field: 'id',
    label: 'Remove',
    sortable: false,
    cell: 'deleteBtn'
  }
]




